import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Api } from '../../services/api';
import { RegionService } from '../../services/region.service';
import { AlertService } from '../../services/alert.service';
import { CommonModule } from '@angular/common';
import { jwtDecode } from 'jwt-decode';


@Component({
  selector: 'app-mdl-manage-prospect',
  standalone: true,
  imports: [FormsModule,CommonModule],
  templateUrl: './mdl-manage-prospect.html',
  styleUrl: './mdl-manage-prospect.css'
})
export class MdlManageProspect implements OnInit{
  private api = inject(Api);
  private regionService = inject(RegionService);

  public regiones: { NombreRegion: string }[] = [];
  public comunas: string [] = [];
  private alertService = inject(AlertService);


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlManageProspect>
  ){}
  public prospecto: any = {};
  public request: any = {
    prospecto_id: "f433d88e-85f8-420f-8ab2-00a787def6e4",
    nombre: "",
    apellido: "",
    email: "",
    telefono: "",
    celular: "",
    cargo: "",
    empresa: "",
    sitio_web: "",
    id_estado: "",
    ejecutivo_id: "",
    industria_id: "",
    empleados: "",
    origen: "",
    direccion: "",
    calle: "",
    ciudad: "",
    region: "",
    pais: "Chile"
  }

  public industrias: any[] = [];
  public loggedUserName: string = '';
  public estados: any = [];


  ngOnInit(): void {
    const token = localStorage.getItem('crmtoken');
    if (token) {
        const decodedToken: any = jwtDecode(token);
        this.loggedUserName = `${decodedToken.nombre} ${decodedToken.apellido}`;
    }else{
        this.loggedUserName = 'Usuario desconocido';
    }

    this.regiones = this.regionService.getRegionesFull();
    console.log(this.data);
    if(this.data.mode === "create"){
      console.log(this.regiones);
      this.request.region = this.regiones[0].NombreRegion;
      this.getComunas(this.request.region);
      this.request.ciudad = this.comunas[0];
    }
    if(this.data.mode === "edit"){
      this.prospecto = this.data.prospecto;
      this.request.prospecto_id = this.prospecto.prospecto_id;
      this.request.id_estado = this.prospecto.id_estado || '';
      this.request.nombre = this.prospecto.nombre || '';
      this.request.apellido = this.prospecto.apellido || '';
      this.request.email = this.prospecto.email || '';
      this.request.telefono = this.prospecto.telefono || '';
      this.request.celular = this.prospecto.celular || '';
      this.request.cargo = this.prospecto.cargo || '';
      this.request.empresa = this.prospecto.empresa || '';
      this.request.sitio_web = this.prospecto.sitio_web || '';
      this.request.id_estado = this.prospecto.id_estado || '';
      this.request.industria_id = this.prospecto.industria_id || '';
      this.request.empleados = this.prospecto.empleados || '';
      this.request.origen = this.prospecto.origen || '';
      this.request.direccion = this.prospecto.direccion || '';
      this.request.calle = this.prospecto.calle || '';
      this.request.ciudad = this.prospecto.ciudad || '';
      this.request.region = this.prospecto.region || '';
        if (this.request.region) {
         this.getComunas(this.request.region);}
      this.request.pais = this.prospecto.pais || '';
    }

    this.getIndustries();
    this.getEstadosProspecto();
  }

  getIndustries(): void {
    this.api.getIndustrias().subscribe({
      next: (resp: any) => {
        this.industrias = resp.data;
        console.log('Industrias obtenidas:', this.industrias);
        if (this.data.mode === 'create' && this.industrias.length > 0 && !this.request.industria_id) {
        this.request.industria_id = this.industrias[0].industria_id;
      }
      },
      error: (err: any) => {
        console.error('Error al obtener las industrias:', err);
      }
    });
  }

  getEstados(): void {
    this.api.getStatusByType({ tipo: 'PRO' }).subscribe({
      next: (resp: any) => {
        this.estados = resp.data;
        console.log('Estados obtenidos:', this.estados);
      },
      error: (err: any) => {
        console.error('Error al obtener los estados:', err);
      }
    });
  }

  

  closeMdl(){
    this.mdl.close();
  }

  updateProspect(){
    console.log('🛰️ Enviando request:', this.request); 

    this.api.showLoading();
    try {
      this.api.updateProspect(this.request).subscribe({
      next: (data:any) =>{

        console.log('prospecto actualizado',data);
        this.api.hideLoading();
        this.mdl.close(true);
      },
      error: (err) =>{
        this.api.hideLoading();
        if (err?.status===403){
          this.alertService.error('Acceso denegado',"No tienes permiso para modificar prospectos.");
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al modificar el prospecto.')
        this.mdl.close(false);
      }
    })
    } catch (error) {
      console.error(error);
    }
  }

  createProspect(){
    this.api.showLoading();
    console.log('🛰️ Enviando request:', this.request);
    try {
      this.api.createProspect(this.request).subscribe({
        next: (data:any) =>{
          setTimeout(() => {
            this.api.hideLoading();
            this.mdl.close(true);
          });
        },
        error: (err) =>{
          this.api.hideLoading();
         if (err?.status === 403) {
        this.alertService.error('Acceso denegado', 'No tienes permiso para crear prospectos.');
        this.mdl.close(false); 
        return;
      }

         this.alertService.error('Error','Ocurrió un problema al crear el prospecto.')
          this.mdl.close(false);
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getComunas(region:string){
    this.comunas = this.regionService.getComunasByRegion(region);
    this.request.ciudad = this.comunas[0];
  }

  getEstadosProspecto(): void {
    this.api.getStatusByType({tipo:"PRO"}).subscribe({
      next: (resp: any) => {
        this.estados = resp.data;
        if(this.data.mode === "create"){
          const defaultStatus = this.estados?.find((estado: any) => estado.orden === 1);
          if (defaultStatus && !this.request.id_estado) {
            this.request.id_estado = defaultStatus.id_estado;
          }
        }
      },
      error: (err: any) => {
        console.error('Error al obtener los estados de prospecto:', err);
      }
    });
  }
}
